module.exports = __webpack_public_path__ + "img/06.ce6b45c1.png";